/**
 * Defines a mixin that enables loading of a single instance.
 * @returns {Mixin}
 */
export default function loadable(source) {
  return (Base) => class LoadableMixin extends Base {
    static implements(mixin) {
      return mixin === loadable || super.implements(mixin);
    }

    static async load(api, ...args) {
      return source(api)(...args)
        .then(({ body }) => body);
    }
  };
}
